import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Breadcrumbs from '../../../../../components/UI/Breadcrumbs';
import { translate, showMessageToastCustom, groupBy } from '../../../../../utils/util';
import { ENUMS } from '../../../../../utils/constants';
import ScannerCode from '../../../../../components/UI/ScannerCode';
import InputUI from '../../../../../components/UI/InputUI';
import DeliveryService from '../../../../../services/DeliveryService';
import { endLoading, startLoading } from '../../../../../actions/loadingAction';
import { validateInputsRequired } from '../../../../../utils/handleChangeHooks';

const StartDelivery = (props) => {
    const [qrCode, setQRCode] = useState({ dolly: {}, frame: {} });
    const [groupQrCode, setGroupQrCode] = useState([]);
    let dollyParams = props.location?.state?.dolly;

    useEffect(() => {
        props.startLoading();
        props.getGroupUser((data) => {
            if (data) {
                let groupOrderRoute = [];
                if (data.groupOrdesDelivery) {
                    groupOrderRoute = groupBy(data.groupOrdesDelivery.filter((i) => i.routeId !== null), 'routeId');
                }

                const route = groupOrderRoute.length > 1 ? '../delivery/ordersRoute' : '../delivery/orders'
                props.hideLoading();
                return props.history.replace({
                    pathname: route
                });
            }
            else if (dollyParams) {
                getDolly(dollyParams);
            }
            props.hideLoading();
        })
        // eslint-disable-next-line
    }, []);

    const getDolly = (dolly) => {
        props.getQrCode(dolly, (data) => {
            if (data.qrCodeTypeId === ENUMS.eQrCodeType.Dolly.value) {
                qrCode.dolly = data
                setQRCode(qrCode);
                if (dollyParams) {
                    document.getElementById('qrCodeDolly').value = qrCode.dolly.code;
                    document.getElementById('qrCodeDolly').labels[0].className = 'active';
                }
            } else {
                qrCode.dolly = {};
                setQRCode(qrCode);
                return showMessageToastCustom(translate('warning', 'general'), translate('delivery:message.informedQrCodeDolly'), 8000, 'mdi mdi-alert-circle-outline red-text');
            }
        })
    }

    const getFrame = (frame) => {
        props.getQrCode(frame, (data) => {
            if (data.qrCodeTypeId === ENUMS.eQrCodeType.Frame.value) {
                qrCode.frame = data
                setQRCode(qrCode);
            } else {
                qrCode.frame = {};
                setQRCode(qrCode);
                return showMessageToastCustom(translate('warning', 'general'), translate('delivery:message.informedQrCodeFrame'), 8000, 'mdi mdi-alert-circle-outline red-text');
            }
        })
    }

    const scanner = (dolly, frame) => {
        if (dolly !== undefined && qrCode.dolly?.code !== dolly) {
            getDolly(dolly);
        }
        if (frame !== undefined && qrCode.frame?.code !== frame) {
            getFrame(frame);
        }
    };

    const addGroupQrCode = () => {
        if (validateInputsRequired("formStartDelivery")) {
            const array = [];
            Object.assign(array, groupQrCode);
            if (array.find((item) => item.frame.id === qrCode.frame.id || item.dolly.id === qrCode.dolly.id)) {
                showMessageToastCustom(translate('warning', 'general'), translate('delivery:message.informedQrCodeAlreadyInserted'), 8000, 'mdi mdi-alert-circle-outline red-text');
                return;
            }
            array.push(qrCode)
            setGroupQrCode(array);
            setQRCode({ dolly: {}, frame: {} });
            document.getElementById('qrCodeDolly').value = '';
            document.getElementById('qrCodeFrame').value = '';
        }
    }

    const removedGroupQrCode = (qrCodeProps) => {
        const items = groupQrCode.filter((data) => data.frame.id !== qrCodeProps.frame.id && data.dolly.id !== qrCodeProps.dolly.id);
        if (items) {
            setGroupQrCode(items);
        }
    }

    const startDelivery = () => {
        props.startDelivery(groupQrCode, (group) => {
            if (group) {
                let groupOrderRoute = [];
                if (props.groupDelivery?.groupOrdesDelivery) {
                    groupOrderRoute = groupBy(props.groupDelivery?.groupOrdesDelivery.filter((i) => i.routeId !== null), 'routeId');
                }

                return props.history.replace({
                    pathname: groupOrderRoute.length > 1 ? '../delivery/ordersRoute' : '../delivery/orders'
                });
            }
        });
    }

    return (
        <>
            <Breadcrumbs id="idBreadcrumbs" title={{ icon: "mdi mdi-cart-check", label: translate('general.startDelivery', 'delivery') }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div id="formStartDelivery" className="card-content" style={{ padding: '8px', paddingBlockEnd: '8px' }}>
                            <fieldset className='fieldset'>
                                <legend style={{ padding: '0 5px' }}>
                                    {translate('delivery:fields.qrCode')}
                                </legend>
                                <div className="input-field no-padding col s12">
                                    <ScannerCode onScanner={scanner} />
                                    <InputUI
                                        required
                                        id='qrCodeDolly'
                                        name='qrCodeDolly'
                                        type="text"
                                        label={translate('delivery:fields.dolly')}
                                        onBlur={(event) => scanner(event.target?.value, undefined)}
                                        defaultValue={qrCode.dolly.code}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <ScannerCode onScanner={scanner} />
                                    <InputUI
                                        required
                                        id='qrCodeFrame'
                                        name='qrCodeFrame'
                                        type="text"
                                        label={translate('delivery:fields.frame')}
                                        onBlur={(event) => scanner(undefined, event.target?.value)}
                                        defaultValue={qrCode.frame.code || ""}
                                    />
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div className="row" style={{ marginBottom: '0px' }}>
                        <button
                            type="button"
                            onClick={addGroupQrCode}
                            className="col s12 m3 btn btn-principal waves-effect waves-light"
                            style={{ width: '100%' }}
                        >
                            {translate('delivery:general.add')}
                        </button>
                    </div>
                    {
                        groupQrCode.length > 0 && (
                            <div className="card">
                                <div className="card-content" style={{ padding: '3px', paddingBlockEnd: '1px' }}>
                                    <div className="row" style={{ paddingTop: '3px' }}>
                                        {
                                            groupQrCode.map((item) => (
                                                <div key={`${item.frame.code} - ${item.dolly.code}`} className="no-padding col s12">
                                                    <div key={item.dolly.id} className="title sixth-text-color" style={{ fontSize: '1rem' }}>
                                                        <i onClick={() => removedGroupQrCode(item)} className={`mdi mdi-24px mdi-alpha-x-circle-outline`} />
                                                        {item.dolly.code} / {item.frame.code}
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {
                        groupQrCode.length > 0 && (
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <button
                                    type="button"
                                    onClick={startDelivery}
                                    className="col s12 m3 btn btn-principal waves-effect waves-light"
                                    style={{ width: '100%', backgroundColor: '#4caf50ba' }}
                                >
                                    {translate('delivery:general.iniciate')}
                                </button>
                            </div>
                        )
                    }
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        filter: state.linePickingReducer.filter,
        groupDelivery: state.deliveryReducer.deliveryGroup
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getQrCode: (code, callback) => {
            dispatch(DeliveryService.getQrCode(code, callback));
        },
        startDelivery: (filter, callback) => {
            dispatch(DeliveryService.startDelivery(filter, callback))
        },
        getGroupUser: (callback) => {
            dispatch(DeliveryService.getGroupUser(callback))
        },
        hideLoading: () => {
            dispatch(endLoading());
        },
        startLoading: () => {
            dispatch(startLoading());
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StartDelivery)));